import React from "react";

interface TitleProps {
  text?: string;
  className?: string;
  children?: React.ReactNode;
}

const Title: React.FC<TitleProps> = ({ text, className, children }) => {
  return (
    <div
      className={`text-black text-start text-xxl font-semibold mb-2 mt-2 ${className}`}
    >
      {text}
      {children}
    </div>
  );
};

export default Title;
